module.exports = __webpack_public_path__ + "assets/mozilla_firefox.9af62f24.png";